module.exports = __webpack_public_path__ + "media/images/kinetix_favicon100x100-6c89dba7e51a0f1d0e0638b78ed31f42.png";